import React, { createContext, useContext } from "react";
import type { TrendDataVersionContext } from "./dataVersion";

const TrendDataContext = createContext<TrendDataVersionContext | null>(null);

export const TrendDataProvider: React.FC<
  React.PropsWithChildren<TrendDataVersionContext>
> = ({ children, version, dataRoot }) => (
  <TrendDataContext.Provider value={{ version, dataRoot }}>
    {children}
  </TrendDataContext.Provider>
);

export function useTrendData(): TrendDataVersionContext {
  const context = useContext(TrendDataContext);

  if (!context) {
    throw new Error("useTrendData must be used within TrendDataProvider");
  }

  return context;
}
